(() => {
  if (window.__c_page_contact_form_initialized) return;
  window.__c_page_contact_form_initialized = true;

  /**
   * 姓・名フィールドの値を結合し、Salesforce送信用の name hidden に反映する。
   * @param {HTMLFormElement} form
   */
  function bindNameSync(form) {
    const lastNameInput = form.querySelector('input[name="contact[last_name]"]');
    const firstNameInput = form.querySelector('input[name="contact[first_name]"]');
    const nameInput = form.querySelector('input[name="name"]');
    if (!lastNameInput || !firstNameInput || !nameInput) return;

    const sync = () => {
      const last = lastNameInput.value.trim();
      const first = firstNameInput.value.trim();
      nameInput.value = [last, first].filter(Boolean).join(' ');
    };

    form.addEventListener('submit', sync);
  }

  /* ------------------------------
    reCAPTCHA（Salesforce Web-to-Case 連携）
  ------------------------------*/

  /**
   * エラー表示要素にメッセージを出し入れする。
   * @param {HTMLElement|null} element
   * @param {string} message 空文字なら非表示にする
   */
  function setRecaptchaError(element, message) {
    if (!element) return;
    element.textContent = message || '';
    element.hidden = !message;
  }

  /**
   * captcha_settings の ts に現在時刻を書き込む。
   * Salesforce は ts とサーバー時刻を突き合わせて検証しており、ts が空のまま送信されると
   * 画面上は成功に見えるのにケースが登録されず消失する。必ず動かし続けること。
   */
  function timestamp() {
    const settings = document.getElementsByName('captcha_settings')[0];
    if (!settings) return;

    const response = document.getElementById('g-recaptcha-response');
    if (response == null || response.value.trim() === '') {
      try {
        const elems = JSON.parse(settings.value);
        elems.ts = JSON.stringify(new Date().getTime());
        settings.value = JSON.stringify(elems);
      } catch (e) {
        /* 値が壊れている場合は上書きしない（毎回のエラー出力も避ける） */
      }
    }
  }

  /**
   * ts 更新ループを開始する。多重起動しない。
   */
  function startTimestampLoop() {
    if (window.__c_page_contact_form_timestamp_started) return;
    if (!document.getElementsByName('captcha_settings')[0]) return;
    window.__c_page_contact_form_timestamp_started = true;
    setInterval(timestamp, 500);
  }

  /**
   * reCAPTCHA の送信前チェックと有効期限切れハンドリングを結び付ける。
   * grecaptcha が未定義（未読み込み・無効）のときは素通しし、既存の送信動作を壊さない。
   * @param {HTMLFormElement} form
   */
  function bindRecaptcha(form) {
    const wrapper = form.querySelector('.c_page-contact-form__recaptcha');
    if (!wrapper) return;

    const errorElement = wrapper.querySelector('[data-recaptcha-error]');
    const requiredMessage = wrapper.dataset.recaptchaRequired || '';
    const expiredMessage = wrapper.dataset.recaptchaExpired || '';

    /* チェックが入ったらエラーを消す（reCAPTCHA は data-callback でのみ通知可能） */
    window.tabioRecaptchaFilled = () => {
      setRecaptchaError(errorElement, '');
    };

    /* v2 のトークンは約2分で失効する */
    window.tabioRecaptchaExpired = () => {
      setRecaptchaError(errorElement, expiredMessage);
    };

    form.addEventListener('submit', (event) => {
      const available =
        typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.getResponse === 'function';
      if (!available) return;

      if (window.grecaptcha.getResponse().length > 0) {
        setRecaptchaError(errorElement, '');
        return;
      }

      event.preventDefault();
      setRecaptchaError(errorElement, requiredMessage);
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /**
   * Salesforce送信後の retURL（?submitted=1）を検知し、完了メッセージを表示する。
   * 表示後はURLからパラメータを除去し、リロード時の再表示を防ぐ。
   * @param {ParentNode} root
   */
  function showSuccessIfSubmitted(root) {
    const params = new URLSearchParams(window.location.search);
    if (params.get('submitted') !== '1') return;

    const success = root.querySelector('.c_page-contact-form__success');
    if (success) {
      success.hidden = false;
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    params.delete('submitted');
    const query = params.toString();
    const newUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  /**
   * SKU から品番のみを取り出す。
   * Tabio の SKU は 11 桁（先頭9桁 = 品番 / 末尾2桁 = カラーコード）で、品番欄にカラーコードは入れない。
   * 11 桁以外はそのまま返すため、既に品番（9桁）のURLを再読込しても二重に削られない。
   * @param {string} sku
   * @returns {string}
   */
  function toItemCode(sku) {
    const value = sku.trim();
    return value.length === 11 ? value.slice(0, 9) : value;
  }

  /**
   * URLの ?sku= を読み取り、品番フィールドに自動入力する（商品ページからの遷移時）。
   * @param {HTMLFormElement} form
   */
  function prefillSkuFromQuery(form) {
    const sku = new URLSearchParams(window.location.search).get('sku');
    if (!sku) return;
    // id は数字始まり（00N...）で CSS の #id セレクタが使えないため属性セレクタで取得する
    const skuField = form.querySelector('[name="00N0o00000MVWGU"]');
    if (skuField) skuField.value = toItemCode(sku);
  }

  /**
   * URLの ?subject= を読み取り、カテゴリ選択（name="subject"）を該当値に設定する。
   * 一致するオプションが無い場合は何もしない。
   * @param {HTMLFormElement} form
   */
  function prefillCategoryFromQuery(form) {
    const subject = new URLSearchParams(window.location.search).get('subject');
    if (!subject) return;
    const select = form.querySelector('select[name="subject"]');
    if (!select) return;
    const matched = Array.from(select.options).some((option) => option.value === subject);
    if (matched) select.value = subject;
  }

  /**
   * 指定ルート配下の c_page-contact-form を初期化する。
   * @param {ParentNode} root
   */
  function init(root) {
    root.querySelectorAll('.c_page-contact-form__form').forEach((form) => {
      bindNameSync(form);
      /* 姓名結合（submit）より後に登録し、結合後に送信中止できるようにする */
      bindRecaptcha(form);
      prefillSkuFromQuery(form);
      prefillCategoryFromQuery(form);
    });
    startTimestampLoop();
    showSuccessIfSubmitted(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  }
})();
